var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-item-group',{attrs:{"mandatory":"","multiple":_vm.multiple},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }